(function(){
  if (window.__brfOct24b) return; window.__brfOct24b = 1;
  var doc = document;
  function tidy(){ payOff('.product-form__info-content'); qvRow(); }
  /* product page: how far the price column sits from the left of its row */
  function payOff(sel){
    [].forEach.call(doc.querySelectorAll(sel), function(c){
      c.setAttribute('data-brf-pay-m', '');
      if (!c.querySelector(':scope > .brf-cpwrap, .brf-kl-line')) return;
      var row = c.closest('.product-form__info-item'); if (!row || c.closest('.modal')) return;
      var off = Math.round(c.getBoundingClientRect().left - row.getBoundingClientRect().left);
      if (off > 4) { c.setAttribute('data-brf-pay-off', ''); c.style.setProperty('--brf-pay-off', off + 'px'); }
      else c.removeAttribute('data-brf-pay-off');
    });
  }
  function qvRow(){
    /* quick view: "Length (metres):" as tall as the quantity box, text centred, so they line up */
    [].forEach.call(doc.querySelectorAll('.modal[id^="modal-quick-view"] .product-form__info-item--quantity'), function(r){
      var t = r.querySelector('.product-form__info-title'), b = r.querySelector('quantity-picker, .quantity-selector');
      if (!t || !b || !b.offsetHeight) return;
      var h = b.offsetHeight + 'px';
      if (r.style.alignItems !== 'flex-start') r.style.alignItems = 'flex-start';
      if (t.style.minHeight !== h) { t.style.display = 'flex'; t.style.alignItems = 'center'; t.style.minHeight = h; t.style.marginTop = '0'; t.style.marginBottom = '0'; }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', tidy); else tidy();
  window.addEventListener('load', tidy);
  window.addEventListener('resize', tidy, {passive: true});
  setInterval(tidy, 700);
  /* picking a length redraws the price block; measure the new one before it is painted, so the Clearpay / Klarna box does not jump (Abid, 2026-10-26) */
  if (window.MutationObserver) new MutationObserver(function(){ payOff('.product-form__info-content:not([data-brf-pay-m])'); }).observe(doc.documentElement, {childList: true, subtree: true});
})();
